import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import rightimg from "../../../Assets/img/Login/login-right.png";
import logo from "../../../Assets/img/Login/logo.png";
import CustomInput from "../../InputCompo/CustomInput";
import * as Yup from "yup";
import { LoginPageDocuments as documents } from "./documents";
import { useFormik } from "formik";
import { ParagraphComp } from "../../ParagraphComp/ParagraphComp";
import { InputCompo } from "../../InputCompo/InputCompo";
import ButtonComp from "../../ButtonComp/ButtonComp";
import { Link } from "react-router-dom";
import EastIcon from "@mui/icons-material/East";
import { useMutation } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { login } from "../../../Store/auth/login";
import ForgetPassword from "./Popups/ForgetPassword";
import NewPassword from "./Popups/NewPassword";
import NeedHelp from "./Popups/NeedHelp";

const LoginPage = () => {
  const [forgetPassword, setForgetPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(false);
  const [needHelp, setNeedHelp] = useState(false);
  // const [getEmail, setGetEmail] = useState(false);


  const handleforgetPassword = () => {
    setForgetPassword(!forgetPassword);
  };

  const handleNewPassword = () => {
    setNewPassword(!newPassword);
  };

  const handleNeedHelp = () => {
    setNeedHelp(!needHelp);
  };
  // const handleGetEmail = () => {
  //   setGetEmail(!getEmail);
  // };

  const modelSchema = Yup.object().shape(
    documents.reduce((schema, field) => {
      if (field.mandatory === 1 && field.type.toLowerCase() !== "section") {
        let validator = Yup.string().required(`${field.question} is required`);

        schema[field.question_no] = validator;
      }

      return schema;
    }, {})
  );
  const formik = useFormik({
    initialValues: {
      ...documents.reduce((values, field) => {
        values[field.question_no] = "";
        return values;
      }, {}),
    },

    validationSchema: modelSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        // Convert the form data into a flat object
        const tempData = {
          ...documents.reduce((acc, field) => {
            acc[field.question_no] = values[field.question_no];
            return acc;
          }, {}),
        };

        // Merge new data with existing data
        const updatedData = {
          ...tempData,
        };

        await loginMutate(updatedData);
      } catch (error) {
      } finally {
        setSubmitting(false);
      }
    },
  });
  const handleCreateSuccess = () => {
    enqueueSnackbar("Login success!", { variant: "success" });
  };

  const handleCreateError = (error) => {
    if (error?.response?.data.status_code >= 500) {
      enqueueSnackbar(error?.response?.data?.status_message, {
        variant: "error",
      });
    } else {
      enqueueSnackbar(error?.response?.data?.message || error?.message, {
        variant: "error",
      });
    }
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };

  //getting mutation alerts

  const {
    mutate: loginMutate,
    // isPending: addLoading,
    data: loginData,
  } = useMutation({
    mutationFn: login,
    ...createFarmerMutationOptions,
  });

  return (
    <Box sx={{ maxWidth: "100vw", overflow: "hidden", color: "black" }}>
      <Box
        sx={{
          maxWidth: "1200px",
          margin: "auto",
          display: "flex",
          flexWrap: "wrap",
          padding: 4,
        }}
      >
        <Box sx={{ width: "45%", display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              justifyContent: "center",
              alignItems: "center",
              width: "340px",
              margin: "auto",
            }}
          >
            <img src={logo} alt="" width="300px" />
            <Box>
              <Typography
                variant="h2"
                sx={{ fontWeight: 700, textAlign: "center", fontSize: "54px" }}
              >
                WELCOME
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 400, fontSize: "12px", textAlign: "center" }}
              >
                We are glad to see you back with us
              </Typography>
            </Box>
            <form action="" onSubmit={formik.handleSubmit} className="w-[100%]">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "100%",
                }}
              >
                {documents?.map((Fields) => (
                  <>
                    {Fields.type.toLowerCase() === "text" ||
                      Fields.type.toLowerCase() === "number" ||
                      Fields.type.toLowerCase() === "date" ? (
                      <div className="w-[100%]">
                        <CustomInput
                          required
                          {...formik.getFieldProps(Fields.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                          onBlur={formik.handleBlur}
                        />
                        <ParagraphComp
                          className="text-[red] text-[10px] px-[8px] mt-1"
                          text={
                            formik.values?.[Fields.question_no] &&
                            formik.errors?.[Fields.question_no]
                          }
                        />
                        <ParagraphComp
                          className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                          text={Fields.description}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ))}
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <label className="flex items-center space-x-2">
                    <InputCompo
                      className="bg-[#004878] text-white w-[20px] h-[20px]"
                      type="checkbox"
                    // name={item.name}
                    // checked={formik.values[item.name]}
                    // onChange={formik.handleChange}
                    // onBlur={formik.handleBlur}
                    />
                    <span className="text-black text-sm font-semibold">
                      Remember me
                    </span>
                  </label>
                  <Button
                    onClick={handleforgetPassword}
                    variant="text"
                    disableRipple
                    sx={{
                      color: "#004878",
                      padding: "0",
                      textTransform: "inherit",
                      letterSpacing: "-.5px",
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                  >
                    Forget Password ?
                  </Button>
                </Box>
                <div className="flex justify-center">
                  <ButtonComp
                    type={"submit"}
                    text={"Login"}
                    className="px-[50px] rounded-full bg-[#ED1C24] text-[white] py-[10px] leading-5"
                  />
                </div>
              </Box>
            </form>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
              }}
            >
              <ParagraphComp
                className="text-black text-xs font-semibold"
                text="Want to register your organisation? Only ITPAN & Trust/ Society/ Sec 8 Co. (formerly sec 25) registration certificate required. "
              />
              <Link to="/registration" className="flex justify-start">
                <Button
                  variant="text"
                  disableRipple
                  sx={{
                    color: "#004878",
                    padding: "0",
                    textTransform: "inherit",
                    letterSpacing: "-.5px",
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                >
                  Register here for free &nbsp; <EastIcon fontSize="small" />
                </Button>
              </Link>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            width: "55%",
            backgroundColor: "#EFF8F4",
            borderRadius: "30px",
            padding: "0 30px",
          }}
        >
          <img src={rightimg} alt="" width="100%" />
        </Box>
      </Box>
      <ForgetPassword isOpen={forgetPassword} onClose={handleforgetPassword} />
      <NewPassword isOpen={newPassword} onClose={handleNewPassword} />
      <NeedHelp isOpen={needHelp} onClose={handleNeedHelp} />
    </Box>
  );
};

export default LoginPage;
